import { Pipe, PipeTransform } from '@angular/core';


/**------------------------------------------------------
 * Format Input to Local Format Conversion
 * ---------------------------------------
 * Usage:
 * 	value (type any) | ngFormatNumber
 * Example:
 * 	{{ totalDesigns | ngFormatNumber }}
 *  convert total designs number to LocaleString
 */
@Pipe({
    name: 'ngFormatNumber',
    standalone: false
})
export class NgFormatNumberPipe implements PipeTransform {

	transform(value: any, localFormat?: string): string {
		return Number(value).toLocaleString(localFormat);
	}
}
